<template>
  <div class="modal_wrap on" v-if="dialogVisible">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">업데이트 알림</h1>
        </div>
        <div class="modal_con">
          <div class="modal_txt">
            <div class="center">
              보다 나은 서비스를 위해<br />
              지금 바로 업데이트 해주세요
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" @click="handleUpdate">
              업데이트 하러 가기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  checkMobileOperatingSystem,
  nativeBrowse,
} from '@common/lib/common/utils';
export default {
  data() {
    return {
      dialogVisible: true,
    };
  },
  computed: {},
  methods: {
    visible(v) {
      this.dialogVisible = v;
    },
    async handleUpdate() {
      this.visible(false);
      if (checkMobileOperatingSystem() === 'iOS') {
        nativeBrowse(
          'https://apps.apple.com/us/app/%ED%8D%BC%EC%8A%A4-perce/id1569722707',
        );
      } else {
        nativeBrowse(
          'https://play.google.com/store/apps/details?id=com.appg.perce_customer',
        );
      }
    },
  },
};
</script>

<style></style>
